import $ from 'jquery';

export default class SliderVideo {
  constructor(config) {
    this._video = config.video[0];
    this._init();
  }

  _init() {
    var video = this._video;	
    var slider = $(video).closest('.section_slider');

    $(window).scroll(function() {
      if ($(slider).offset().top - $(window).height() / 2 < $(window).scrollTop()) {
        if (video.currentTime < 0.1) {
          setTimeout(function() {
            video.play().then(() => {}).catch(() => {
              $(video).attr('controls', 'controls');
            });
          }, 300);
        }
      }
    });
  }
}
